import { Check, Delete } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import { useState } from "react";

// Names or deletes a point of interest. The name is only saved on Enter or
// the check button. Mounted per point, so it starts from `initialLabel`.
export const POIEditor = ({
	initialLabel,
	onSave,
	onDelete,
}: {
	initialLabel: string;
	onSave: (label: string) => void;
	onDelete: () => void;
}) => {
	const [label, setLabel] = useState(initialLabel);

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: "2px",
				p: "4px",
				background: "white",
				borderRadius: "6px",
				boxShadow: 2,
			}}
		>
			<TextField
				autoFocus
				size="small"
				placeholder="Name"
				value={label}
				onChange={(e) => setLabel(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === "Enter") onSave(label.trim());
				}}
				sx={{ width: 180 }}
			/>
			<IconButton aria-label="save point" size="small" onClick={() => onSave(label.trim())}>
				<Check color="primary" />
			</IconButton>
			<IconButton aria-label="delete point" size="small" onClick={onDelete}>
				<Delete color="error" />
			</IconButton>
		</Box>
	);
};
